import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const postCalendar = data => {
  return api.post(`/admin/calendar`, data);
};

export const usePostCalendarMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postCalendar,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.invalidateQueries({ queryKey: ["calendars"] });
      queryClient.invalidateQueries({ queryKey: ["calendar"] });
      queryClient.invalidateQueries({ queryKey: ["calendar-date-range"] });
    },
    ...restConfig,
  });
};
